import {useQuery} from 'react-query'
import {ResellerGroupEditModalForm} from './ResellerGroupEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getResellerGroupById} from '../core/_requests'

const ResellerGroupEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: resellergroup,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-resellergroup-${itemIdForUpdate}`,
    () => {
      return getResellerGroupById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )
  if (!itemIdForUpdate) {
    return <ResellerGroupEditModalForm isResellerGroupLoading={isLoading} resellergroup={{id: undefined}} />
  }

  if (!isLoading && !error && resellergroup) {
    console.log({resellergroup, },"its resellergroup")
    console.log(typeof resellergroup,"its resellergroup")
    return <ResellerGroupEditModalForm isResellerGroupLoading={isLoading} resellergroup={resellergroup} />
  }

  return null
}

export {ResellerGroupEditModalFormWrapper}
